
let home = {
    systemMsg: '系统公告',
    link: '推广链接',
    editPwd: '修改密码',
    withDraw: '出金申请',
    withDrawCheck: '出金审核',
    staticReport: '统计报告',
    rebateHistory: '佣金历史',
    transferCheck: '转账审核',
    transferApply: '转账申请',
    logout: '退出登录',
    oldPwd: '原密码',
    addMsg: '发布消息',
    title: '标题',
    content: '内容',
    hint: '提示',
    confirmDel: '确定删除该公告？',
    deleted: '已删除',
    cancleDel: '已取消',
    msgSuccess: '消息发布成功',
    oldPwdError: '原密码输入错误',
    loginAgain: '修改密码成功，请重新登录！',
    noData: '暂无数据',
    /* 出金申请 */
    holderName: '账户持有者姓名',
    enterHolderName: '输入账户持有者姓名',
    accountNumber: '交易账户号码',
    enterAccountNumber: '输入交易账户号码',
    currency: '货币类型',
    selectCurrency: '请选择货币类型',
    amount: '出金金额',
    enterAmount: '输入出金金额',
    balance: '账户余额',
    charge: '手续费',
    enterCharge: '输入手续费',
    payeeName: '收款人姓名',
    enterPayeeName: '输入收款人姓名',
    bankName: '银行名称',
    enterBankName: '输入银行名称',
    province: '银行所在省',
    enterPorvince: '输入省名称',
    city: '银行所在市',
    enterCity: '输入市名称',
    bankBranch: '银行支行名称',
    enterBankBranch: '输入支行名称',
    bankAccount: '银行账号',
    enterBankAccount: '输入银行账号',
    bankSwift: '收款银行SWIFT代码',
    enterBankSwift: '输入收款银行SWIFT代码',
    bankIban: '收款银行IBAN代码',
    enterBankIban: '输入收款银行IBAN代码',
    sortCode: 'Sort code',
    enterSortCode: '输入Sort code',
    setDefaultWithdraw: '设为默认出金信息',
    reset: '重 置',
    submit: '提 交',
    ApplicationInfo: '申请信息',
    selectAppStatus: '请选择申请状态',
    inHand: '处理中',
    figureOut: '处理完成',
    rejected: '已拒绝',
    canceled: '已取消',
    status: '状态',
    regDate: '申请日期',
    confimApp: '已确认申请',
    rufuseApp: '已拒绝申请',
    noBalance: '余额不足',
    unfinished: '您有未完成的出金申请！',
    withdrawSuccess: '出金申请成功',
    addCnName: '请发送邮件至客服部添加中文姓名!',
    enterRefuseReason: '请输入拒绝理由：',
    /* 转账申请 */
    transferAmount: '转账金额',
    enterTransfer: '输入转账金额',
    comment: '备注',
    enterComment: '输入备注信息',
    rollinAccount: '转入账号',
    enterRollinAccount: '输入转入账号',
    enterCorrectRollin: '输入正确的账号',
    updateReason: '更新原因'

}

export default home;




































// WEBPACK FOOTER //
// ./src/i18n/chinese/home.js